import fetcher, { HTTPMethods } from "../hooks/fetcher";
import logger from "../util/logger";

/* Mirrors `errors.response(res).message()`: callers read the top-level message
 * and branch on `errors`, so a fallback missing either renders blank. */
const fallbackError = (message) => ({ message, errors: [{ message }] });

const post = async (url, body, fallbackMessage) => {
  try {
    return await fetcher(url, {
      method: HTTPMethods.POST,
      body: JSON.stringify(body),
    });
  } catch (err) {
    logger.error(err);

    return err.json ?? fallbackError(fallbackMessage);
  }
};

export const setShopStatus = ({ influencerId, isOpen }) =>
  post(
    `/api/influencer/${influencerId}/shopStatus`,
    { isOpen },
    "Unable to update shop status",
  );

export const resolveShopOpenNotice = ({ influencerId, notify }) =>
  post(
    `/api/influencer/${influencerId}/shopOpenNotice`,
    { notify },
    "Unable to update the shop open notice",
  );

export default { setShopStatus, resolveShopOpenNotice };
